import { NgModule } from '@angular/core';
import {Routes, RouterModule } from '@angular/router';
import {CommonModule } from '@angular/common';
import {FormsModule, ReactiveFormsModule } from "@angular/forms";

import {RxFormsModule} from "@rx/forms";
import {RxViewModule} from "@rx/view";
import {    RxTableModule} from "@rx/table";

import { UserListComponent } from './user-list.component'
import { USER_LIST_ROUTING } from './user-list.routing'
import {UsersService } from "../users.service";

@NgModule({
    imports: [
        USER_LIST_ROUTING ,
        CommonModule, RxViewModule, RxTableModule, RxFormsModule, FormsModule, ReactiveFormsModule,
		    ],
    declarations: [UserListComponent ],
    exports: [RouterModule],
    providers: [UsersService]
})
export class UserListModule { }